import React from "react"
import styled from "styled-components"
import { StaticQuery, graphql, Link } from "gatsby"
import CloseIcon from "../Icons/CloseIcon"
import ArrowIcon from "../Icons/ArrowIcon"
import BreakpointUp from "../Media/BreakpointUp"
import BreakpointDown from "../Media/BreakpointDown"
import MenuBackground from "../../images/2.png"

const Background = styled.div`
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    opacity: 0.12;
    background-image: ${(props) => props.bgBefore};
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: cover;
    width: 100%;
  }
`
const Wrapper = styled.div`
  position: fixed;
  z-index: 151;
  top: ${(props) => props.top};
  left: 0;
  display: flex;
  width: 100%;
  min-height: 100vh;
  ${BreakpointDown.lg`
		display: block;
		overflow-y: scroll;
    	height: 100%;
	`}
`
Wrapper.defaultProps = {
  top: "0",
}

const Close = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 102;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  & svg {
    width: 20px;
    height: 20px;
  }
`

const MenuWrap = styled.div`
  width: 100%;
  min-height: 100vh;
  display: ${(props) => props.display};
`

const MenuTitle = styled.div`
  color: #333;
  opacity: 0.1;
  margin-bottom: 20px;
  font-family: "UniNeueBold", sans-serif;
  font-weight: 800;
  font-size: 28px;
  line-height: 30px;
  ${BreakpointUp.sm`
		font-size: 38px;
		line-height: 48px;
	`}
  ${BreakpointUp.xxl`
		font-size: 44px;
		line-height: 54px;
	`}
`
const LeftMenu = styled.div`
  position: relative;
  background: #fab702;
  ${BreakpointUp.lg`
		width: 33.333333%;
	`}
  ${BreakpointUp.xl`
		width: 25%;
	`}
	${BreakpointUp.xxl`
		width: 33.333333%;
	`}
	& a {
    position: relative;
    font-family: "UniNeueBold", sans-serif;
    font-weight: 700;
    color: white;
    display: block;
    z-index: 102;
    font-size: 16px;
    line-height: 28px;
    margin-bottom: 20px;
    display: flex;
    line-height: 24px;
    flex-wrap: nowrap;
    ${BreakpointUp.xxl`  
			font-size: 20px;
			line-height: 34px;
			margin-bottom: 30px;
		`}
    & .icon {
      transition: transform ease 0.2s;
      + .text {
        margin-left: 10px;
      }
    }
    &:hover {
      cursor: pointer;
      & .icon {
        transform: translateX(5px);
      }
    }
  }
`
const LeftMenuBody = styled.div`
  width: 100%;
  padding: 30px 15px;
  ${BreakpointUp.sm`
		padding: 30px;
	`}
  ${BreakpointUp.xl`  
		padding: 60px 45px;
	`}
	${BreakpointUp.xxl`  
		padding: 70px 120px;
	`}
`
const LeftMenuInner = styled.div``

const RightMenu = styled.div`
  position: relative;
  background: white;
  width: 100%;
  ${BreakpointUp.lg`
		width:66.666667%;
	`}
  ${BreakpointUp.xl`
		width: 75%;
	`}
	${BreakpointUp.xxl`  
		width:66.666667%;
	`}
`
const RightMenuBody = styled.div`
  padding: 30px 15px;
  ${BreakpointUp.sm`
		padding: 30px;
	`}
  ${BreakpointUp.xl`  
		padding: 60px 45px;
	`}
	${BreakpointUp.xxl`  
		padding: 80px;
	`}
`
const RightMenuInner = styled.div`
  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }
  ${BreakpointUp.lg`  		
		overflow-y: auto;
		height: calc(100vh - 200px);
	`}
`
const RightMenuGrid = styled.div`
  display: grid;
  justify-content: space-between;
  grid-gap: 15px;
  grid-template-columns: repeat(1, 1fr);
  ${BreakpointUp.sm`  		
		grid-template-columns: repeat(2, 1fr);
	`}
  ${BreakpointUp.xl`  		
		grid-template-columns: repeat(3, 1fr);
	`}
	& strong {
    margin-bottom: 16px;
    display: block;
    color: rgba(51, 51, 51, 0.5);
    margin: 0 0 5px;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;

    & a {
      display: block;
      color: rgba(51, 51, 51, 0.5);
      margin: 0;
      &:hover {
        color: #000;
      }
    }
  }
  & a {
    position: relative;
    font-size: 14px;
    font-weight: 600;
    color: #000;
    display: block;
    margin: 10px 0;
    z-index: 102;
    display: flex;
    line-height: 24px;
    flex-wrap: nowrap;
    cursor: pointer;
    & .icon {
      vertical-align: middle;
      transition: transform ease 0.2s;
      + .text {
        margin-left: 10px;
      }
    }
    &:hover {
      & .icon {
        transform: translateX(5px);
      }
    }
  }
`

class Menu extends React.Component {
  constructor(props) {
    super(props)
    this.closeMenu = this.closeMenu.bind(this)
  }
  closeMenu() {
    const { onClose } = this.props
    onClose()
  }
  render() {
    const { display, top } = this.props
    return (
      <MenuWrap display={display}>
        <Wrapper top={top}>
          <Close onClick={this.closeMenu}>
            <CloseIcon fill="#000" />
          </Close>
          <LeftMenu>
            <LeftMenuBody>
              <Background bgBefore={`url(${MenuBackground})`}></Background>
              <MenuTitle>About AES</MenuTitle>
              <LeftMenuInner>
                <Link to="/about">
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> Who We Are </span>
                </Link>
                <Link to="/timeline">
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> Our History</span>
                </Link>
                <Link to="/cares-team">
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> AES C.A.R.E.S Team</span>
                </Link>
                <Link
                  to="https://recruiting.paylocity.com/recruiting/jobs/All/da9c5e97-8c64-49a3-aaac-4d89309ecf1f/Advanced-Electronic-Services-Inc"
                  target="_blank"
                >
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> Join Our Team</span>
                </Link>
                <Link to="/process">
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> Repair Process</span>
                </Link>
                <Link to="/review">
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> Customer Reviews</span>
                </Link>
                <Link to="/articles">
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> Articles</span>
                </Link>
                <Link to="/faq">
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> FAQ</span>
                </Link>
                <Link to="/videos">
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> Technical Videos</span>
                </Link>
                <Link to="/contact-us">
                  <span className="icon">
                    <ArrowIcon fill="white" />
                  </span>
                  <span className="text"> Contact Information</span>
                </Link>
              </LeftMenuInner>
            </LeftMenuBody>
          </LeftMenu>
          <StaticQuery
            query={graphql`
              query MegaMenuQuery {
                allContentfulServiceSubRepair(sort: { createdAt: ASC }) {
                  nodes {
                    name
                    url
                    service {
                      serviceName
                      url
                    }
                  }
                }
                allContentfulService(sort: { order: ASC }) {
                  nodes {
                    serviceName
                    url
                  }
                }
                allContentfulIndustry {
                  nodes {
                    name
                    url
                  }
                }
              }
            `}
            render={(data) => {
              return (
                <RightMenu>
                  <RightMenuBody>
                    <MenuTitle>Our Repair Services</MenuTitle>
                    <RightMenuInner>
                      <RightMenuGrid>
                        {data.allContentfulService.nodes.map(
                          (service, index) => {
                            return (
                              <div key={index}>
                                <strong>
                                  <Link to={`/${service.url}`}>
                                    {service.serviceName}
                                  </Link>
                                </strong>
                                {data.allContentfulServiceSubRepair.nodes.map(
                                  (subService, index) => {
                                    if (
                                      subService.service.serviceName ===
                                      service.serviceName
                                    ) {
                                      return (
                                        <Link
                                          key={index}
                                          to={`/${subService.url}`}
                                        >
                                          <span className="icon">
                                            <ArrowIcon fill="#FAB702" />
                                          </span>
                                          <span className="text">
                                            {subService.name}
                                          </span>
                                        </Link>
                                      )
                                    } else {
                                      return true
                                    }
                                  }
                                )}
                              </div>
                            )
                          }
                        )}
                        <div>
                          <strong>Industries We Serve!</strong>
                          {data.allContentfulIndustry.nodes.map(
                            (industry, index) => {
                              return (
                                <Link key={index} to={`/${industry.url}`}>
                                  <span className="icon">
                                    <ArrowIcon fill="#FAB702" />
                                  </span>
                                  <span className="text">{industry.name}</span>
                                </Link>
                              )
                            }
                          )}
                        </div>
                      </RightMenuGrid>
                    </RightMenuInner>
                  </RightMenuBody>
                </RightMenu>
              )
            }}
          />
        </Wrapper>
      </MenuWrap>
    )
  }
}

export default Menu
